import { createAppAnalytics } from './appAnalyticsCore';
import type {
  AppAnalytics,
  AppAnalyticsPlatform,
  AppAnalyticsProvider,
} from './appAnalyticsTypes';
import { isElectronRuntime } from '../utils/isElectron';

export type { AppAnalytics } from './appAnalyticsTypes';

function classifyWebPlatform(): AppAnalyticsPlatform {
  return isElectronRuntime() ? 'electron' : 'web';
}

const noopProvider: AppAnalyticsProvider = {
  logEvent: () => undefined,
  setUserId: () => undefined,
  setUserProperties: () => undefined,
};

export const appAnalytics: AppAnalytics = createAppAnalytics(
  noopProvider,
  classifyWebPlatform(),
  { providerDeliversRemotely: false },
);

export default appAnalytics;
